var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgIdm = function SvgIdm(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.68596 2.34961V13.6496H0.9375V2.34961H3.68596Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0625 7.97563C15.0625 9.08379 14.8214 10.0694 14.3392 10.9325C13.8678 11.7849 13.182 12.4509 12.2819 12.9304C11.3925 13.4099 10.3424 13.6496 9.13161 13.6496H4.84015V2.34961H9.13161C10.3531 2.34961 11.4086 2.58403 12.298 3.05286C13.1873 3.5217 13.8678 4.18233 14.3392 5.03476C14.8214 5.88719 15.0625 6.86748 15.0625 7.97563ZM8.89051 11.2042C9.96204 11.2042 10.7925 10.9218 11.3818 10.3571C11.9819 9.79237 12.2819 8.99855 12.2819 7.97563C12.2819 6.95272 11.9819 6.1589 11.3818 5.59416C10.7925 5.02943 9.96204 4.74706 8.89051 4.74706H7.58861V11.2042H8.89051Z",
    fill: "currentColor"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgIdm);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "idm.65ab0a81192641cf7fd209a744cc1c4f.svg";